<template>
	<b-modal
		size="xmd"
		ref="specimen-location-tracking-modal"
		@hidden="$emit('close')"
		ok-title="Guardar"
		:title="`Tracking de ${location.name}`"
		centered
		no-close-on-backdrop
		hide-footer
	>
		<b-table-simple>
			<b-thead class="text-center">
				<b-tr>
					<b-th>Ejemplar</b-th>
					<b-th>Ubicado por</b-th>
					<b-th>Fecha</b-th>
				</b-tr>
			</b-thead>
			<b-tbody class="text-center">
				<b-tr v-for="row in rows" :key="row.id">
					<b-td>
						{{ `${row.specimen_plate} ${row.specimen_alias ? "(" + row.specimen_alias + ")" : ""}` }}
					</b-td>
					<b-td>{{ row.user_name }}</b-td>
					<b-td>
						{{ row.created_at | myGlobalDayWithHour }}
					</b-td>
				</b-tr>
				<b-tr v-if="rows.length == 0">
					<b-td colspan="3">
						<p class="mb-0">No hay registros por mostrar</p>
					</b-td>
				</b-tr>
			</b-tbody>
		</b-table-simple>
	</b-modal>
</template>

<script>
import modalMixin from "@/mixins/modal.js"
import SpecimenLocationService from "@/views/brain/specimens/views/location/services/specimen-location.service.js"
export default {
	props: {
		location: Object,
	},
	name: "SpecimenLocationTrackingModal",
	components: {},
	async mounted() {
		await this.getLocationTracking()
		this.toggleModal("specimen-location-tracking-modal")
	},
	data() {
		return {
			rows: [],
		}
	},

	methods: {
		async getLocationTracking() {
			this.isPreloading()
			try {
				const { data } = await SpecimenLocationService.getLocationTracking(this.location.id)
				this.rows = data
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
	},
	mixins: [modalMixin],
}
</script>

<style></style>
